import React from 'react';

export type FieldsetProps = {
  legend?: string;
  className?: string;
};

export const Fieldset: React.FC<React.PropsWithChildren<FieldsetProps>> = ({ legend, children, className = '' }) => {
  return (
    <fieldset className={`fieldset${className ? ` ${className}` : ''}`}>
      {legend && (
        <legend style={{ fontSize: 'auto' }} className="float-none">
          {legend}
        </legend>
      )}
      {children}
    </fieldset>
  );
};
